function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.774 2.047l-1.82-1.82a.775.775 0 00-1.097 0L8.431 2.654 6.93 1.168 5.833 2.265l1.104 1.104L0 10.306V14h3.694l6.938-6.937 1.104 1.104 1.096-1.096-1.493-1.493 2.427-2.426a.777.777 0 00.008-1.105zM3.049 12.445L1.555 10.95l6.269-6.267 1.493 1.493-6.268 6.268z"
})));